import AxiosInstance from "../Utils/axios/axiosConfig";

export const saveContactUs = async (body) => {
    const response = await AxiosInstance.post("/customer-query/", body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };

export const saveFeedback = async (body) => {
    const response = await AxiosInstance.post("/feedback/", body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };